import { Component, OnInit } from '@angular/core';
import { QuotationService } from '../../services/quotation-service/quotation.service';
import { Router } from '@angular/router';
import { QuotationStep } from '../../model/QuotationStep';
import { QuotationType } from '../../model/QuotationType';

@Component({
  selector: 'app-quotation-tracker',
  templateUrl: './quotation-tracker.component.html',
  styleUrls: ['./quotation-tracker.component.scss']
})
export class QuotationTrackerComponent implements OnInit {

  constructor(public quotationService: QuotationService,
              private router: Router) { }

  ngOnInit() {
    this.quotationService.campaign = sessionStorage.getItem('campaign');
    this.quotationService.platform = sessionStorage.getItem('platform');
    this.quotationService.quotationStep = <QuotationStep> sessionStorage.getItem('quotationStep');
    this.quotationService.quotationType = <QuotationType> sessionStorage.getItem('quotationType');
    if (this.quotationService.quotationStep === QuotationStep.LANDING) {
      this.router.navigateByUrl('choose-insurance-quote');
    }
  }

  isCurrentStep(step: string) {
    return this.quotationService.quotationStep === step;
  }
}
